import { render } from "./PersonalDevelopmentPlanComponent.vue?vue&type=template&id=447b6f48&scoped=true"
import script from "./PersonalDevelopmentPlanComponent.vue?vue&type=script&lang=js"
export * from "./PersonalDevelopmentPlanComponent.vue?vue&type=script&lang=js"

import "./PersonalDevelopmentPlanComponent.vue?vue&type=style&index=0&id=447b6f48&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-447b6f48"

export default script